import { v4 as uuidv4 } from 'uuid';

import { Menu } from '../../../../vtex-apps/menu/Menu/default';
import { MenuItem } from '../../../../vtex-apps/menu/MenuItem/default';
import { FlexLayoutCol, FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { DisclosureLayout } from '../../../../vtex-apps/disclosure-layout/DisclosureLayout/default';
import { DisclosureTrigger } from '../../../../vtex-apps/disclosure-layout/DisclosureTrigger/default';
import { DisclosureContent } from '../../../../vtex-apps/disclosure-layout/DisclosureContent/default';
import { MegaMenuGoBackBtn } from '../../../../vtex-apps/mega-menu/defaultGoBack';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { DisclosureStateIndicator } from '../../../../vtex-apps/disclosure-layout/DisclosureStateIndicator/default';
import { MegaMenu } from '../../../../vtex-apps/mega-menu/default';
import { IconCaret } from '../../../../vtex-apps/icons/default';

const StoreMenuMobile = () => {
	return {
		componentName: 'FlexLayoutRow',
		componentGroup: 'StoreMenuMobile',
		componentId: uuidv4(),
		variables,
		props: FlexLayoutRow({ blockClass: 'menu-mob-2__row' }).props,
		childrenComponents: [
			Menu({
				blockClass: 'menu-mob-2__menu',
				items: [
					MenuItem({
						id: 'menu-item-category-mobile-2',
						type: 'custom',
						itemProps: { categoryId: 10, text: 'Category 17', itemType: 'category' },
					}).props,
					MenuItem({
						id: 'menu-item-category-mobile-2',
						type: 'custom',
						itemProps: { categoryId: 10, text: 'Category 18', itemType: 'category' },
					}).props,
					MenuItem({
						id: 'menu-item-category-mobile-2',
						type: 'custom',
						itemProps: { categoryId: 10, text: 'Category 19', itemType: 'category' },
					}).props,
					MenuItem({
						id: 'menu-item-category-mobile-2',
						type: 'custom',
						itemProps: { categoryId: 10, text: 'Category 20', itemType: 'category' },
					}).props,
					MenuItem({
						id: 'menu-item-category-mobile-2',
						type: 'custom',
						itemProps: { categoryId: 10, text: 'Category 21', itemType: 'category' },
					}).props,
					MenuItem({
						id: 'menu-item-category-apparel',
						type: 'custom',
						itemProps: { text: 'Apparel & Accessories' },
					}).props,
				],
			}),
			FlexLayoutCol({ blockClass: 'menu-mob-2__col', width: '100%' }, [
				DisclosureLayout({ animated: true, initialVisibility: 'visible' }, [
					DisclosureTrigger({ blockClass: 'menu-mob-2__mega-menu' }, [
						RichText({ blockClass: 'menu-mob-2__mega-menu-title', text: 'Todas as categorias' }),
						DisclosureStateIndicator({
							Show: IconCaret({
								orientation: 'up',
								size: 14,
								viewBox: '0 0 16 16',
								handle:
									'caretIcon--menu-mob-2__mega-menu caretIcon vtex-store-icons-0-x-caretIcon vtex-store-icons-0-x-caretIcon--menu-mob-2__mega-menu',
								activeClassName: 'menu-mob-2__mega-menu',
								mutedClassName: 'menu-mob-2__mega-menu',
							}),
							Hide: IconCaret({
								orientation: 'down',
								size: 14,
								viewBox: '0 0 16 16',
								handle:
									'caretIcon--menu-mob-2__mega-menu caretIcon vtex-store-icons-0-x-caretIcon vtex-store-icons-0-x-caretIcon--menu-mob-2__mega-menu',
								activeClassName: 'menu-mob-2__mega-menu',
								mutedClassName: 'menu-mob-2__mega-menu',
							}),
						}),
					]),
					DisclosureContent({}, [
						FlexLayoutRow({ blockClass: 'menu-mob-2__mega-menu-container' }, [
							FlexLayoutCol({ width: '100%' }, [MegaMenuGoBackBtn({ blockClass: 'menu-mob-2__mega-menu' })]),
							MegaMenu({ blockClass: 'menu-mob-2__mega-menu', orientation: 'vertical' }),
						]),
					]),
				]),
			]),
		],
	};
};

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--white', to: '--menu-mob-2-menu-bg-color', name: 'Menu Background' },
			{ from: '--text-color-1-dark', to: '--menu-mob-2-menu-text-color', name: 'Menu Text' },
			{ from: '--neutral-color-high-medium', to: '--menu-mob-2-menuitem-bc', name: 'MenuItem Border' },
			{ from: '--brand-color-primary-pure', to: '--menu-mob-2-mm-title-text-color', name: 'Mega Menu Title' },
			//1st level color
			{
				from: '--text-color-1-dark',
				to: '--menu-mob-2-mm-1st-level-text-color',
				name: 'Mega Menu 1st Level Text',
			},
			//1st level heading
			{
				from: '--text-color-1-dark',
				to: '--menu-mob-2-mm-1st-level-heading-color',
				name: 'Mega Menu 1st Level Heading',
			},
			//2nd level color
			{
				from: '--text-color-1-dark',
				to: '--menu-mob-2-mm-2nd-level-text-color',
				name: 'Mega Menu 2nd Level Text',
			},
			//3rd level color
			{
				from: '--text-color-1-dark',
				to: '--menu-mob-2-mm-3rd-level-text-color',
				name: 'Mega Menu 3rd Level Text',
			},
			//3d level bg color
			{ from: '--white', to: '--menu-mob-2-mm-3rd-level-bg-color', name: 'Mega Menu 3rd Level Background' },
			//go back color
			{
				from: '--brand-color-primary-pure',
				to: '--menu-mob-2-mm-go-back-text-color',
				name: 'Mega Menu Go Back Text',
			},
			//see all color
			{
				from: '--brand-color-primary-pure',
				to: '--menu-mob-2-mm-see-all-text-color',
				name: 'Mega Menu See All Text',
			},
		],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-xs', to: '--menu-mob-2-menu-fs', name: 'Menu' },
			//1st level fs
			{ from: '--font-size-md', to: '--menu-mob-2-mm-1st-level-fs', name: 'Mega Menu 1st Level' },
			//1st level heading fs
			{ from: '--font-size-md', to: '--menu-mob-2-mm-1st-level-heading-fs', name: 'Mega Menu 1st Level Heading' },
			//2nd level fs
			{ from: '--font-size-sm', to: '--menu-mob-2-mm-2nd-level-fs', name: 'Mega Menu 2nd Level' },
			//go back fs
			{ from: '--font-size-xxs', to: '--menu-mob-2-mm-go-back-fs', name: 'Mega Menu Go Back' },
			//see all fs
			{ from: '--font-size-xxs', to: '--menu-mob-2-mm-see-all-fs', name: 'Mega Menu See All' },
		],
	},
	//menuitem borderWidth
	{
		type: 'borderWidth',
		list: [
			{ from: '--border-width-hairline', to: '--menu-mob-2-menuitem-bw', name: 'MenuItem Border' },
			//1st level bw
			{ from: '--border-width-hairline', to: '--menu-mob-2-mm-1st-level-bw', name: 'Mega Menu 1st Level' },
			//2nd level bw
			{ from: '--border-width-hairline', to: '--menu-mob-2-mm-2nd-level-bw', name: 'Mega Menu 2nd Level' },
		],
	},
	{
		type: 'fontWeight',
		list: [
			{ from: '--font-weight-400', to: '--menu-mob-2-menu-fw', name: 'Menu' },
			{ from: '--font-weight-700', to: '--menu-mob-2-mm-title-fw', name: 'Mega Menu Title' },
			//1st level fw
			{ from: '--font-weight-700', to: '--menu-mob-2-mm-1st-level-fw', name: 'Mega Menu 1st Level' },
			//1st level heading fw
			{
				from: '--font-weight-700',
				to: '--menu-mob-2-mm-1st-level-heading-fw',
				name: 'Mega Menu 1st Level Heading',
			},
			//go back fw
			{ from: '--font-weight-700', to: '--menu-mob-2-mm-go-back-fw', name: 'Mega Menu Go Back' },
			//see all fw
			{ from: '--font-weight-700', to: '--menu-mob-2-mm-see-all-fw', name: 'Mega Menu See All' },
		],
	},
	{
		type: 'spacing',
		list: [
			{ from: '--spacing-xxxs', to: '--menu-mob-2-menuitem-lateral-padding', name: 'Menuitem Lateral Padding' },
			{ from: '--spacing-nano', to: '--menu-mob-2-menu-gap', name: 'Menu Items Gap' },
			//1st level gap
			{ from: '--spacing-nano', to: '--menu-mob-2-mm-1st-level-gap', name: 'Mega Menu 1st Level Gap' },
			//2nd level gap
			{ from: '--spacing-nano', to: '--menu-mob-2-mm-2nd-level-gap', name: 'Mega Menu 2nd Level Gap' },
			//3rd level gap
			{ from: '--spacing-nano', to: '--menu-mob-2-mm-3rd-level-gap', name: 'Mega Menu 3rd Level Gap' },
		],
	},
	//typography for menu and submenu
	{
		type: 'typography',
		list: [
			{ from: '--main-font', to: '--menu-mob-2-menu-typography', name: 'Menu' },
			{ from: '--main-font', to: '--menu-mob-2-submenu-typography', name: 'Submenu' },
			//megamenu typography
			{ from: '--main-font', to: '--menu-mob-2-mm-typography', name: 'Mega Menu' },
		],
	},
];

export default StoreMenuMobile;
